import * as Switch from "@radix-ui/react-switch";
import React from "react";
import { cn } from "lib/cn";

export type SwitchInputProps = {
    value?: boolean;
    name: string;
    label: string;
    onChange: (value: boolean) => void;
};

export const SwitchInput = ({ name, label, value, onChange }: SwitchInputProps) => (
    <div className="flex h-full items-center gap-2">
        <Switch.Root
            className={cn(
                "group",
                "radix-state-checked:bg-[#0daaf4]",
                "radix-state-unchecked:bg-slate-200 dark:radix-state-unchecked:bg-[#0daaf4]",
                "relative inline-flex h-[18px] w-[36px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out",
                "focus:outline-hidden focus-visible:ring-3 focus-visible:ring-slate-500/75",
            )}
            id={name}
            onCheckedChange={onChange}
            checked={value || false}
        >
            <Switch.Thumb
                className={cn(
                    "group-radix-state-checked:translate-x-[18px]",
                    "group-radix-state-unchecked:translate-x-[2px]",
                    "pointer-events-none inline-block h-[14px] w-[14px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out",
                    "absolute top-[50%] -translate-y-1/2",
                )}
            />
        </Switch.Root>
        <div>
            <label
                className="cursor-pointer font-sans text-[12px] leading-[169%] font-normal tracking-normal text-[#767676]"
                htmlFor={name}
            >
                {label}
            </label>
        </div>
    </div>
);
